// @flow
import React from 'react';
import 'moment/locale/ja';
import moment from 'moment';
import type { Project } from '../../models/projects/Project';
import { STATUS } from '../../models/projects/Project';

type Props = {
  project: Project,
};

export default function CardStatus(props: Props) {
  const { project } = props;

  if (
    project.status !== STATUS.failed &&
    moment().isAfter(moment(project.start_at)) &&
    project.products_size > 0
  ) {
    if (project.status === STATUS.inProgress) {
      return (
        <div className="status d-flex">
          <div className="flex-fill h-100 border-right d-flex flex-column justify-content-center align-items-center">
            <div className="value">{project.investors_size}人</div>
            <div className="title">投資家</div>
          </div>
          <div className="flex-fill h-100 d-flex flex-column justify-content-center align-items-center">
            <div className="value">{moment(project.finish_at).fromNow()}</div>
            <div className="title">残り</div>
          </div>
        </div>
      );
    } else if (
      project.status <= STATUS.succeeded &&
      project.waiting_wait_order
    ) {
      return (
        <div className="status d-flex">
          <div className="flex-fill h-100 border-right d-flex flex-column justify-content-center align-items-center">
            <div className="value">キャンセル待ち受付中</div>
          </div>
          <div className="flex-fill h-100 d-flex flex-column justify-content-center align-items-center">
            <div className="value">{project.wait_remain_time}</div>
            <div className="title">残り</div>
          </div>
        </div>
      );
    } else if (
      project.status === STATUS.succeeded ||
      project.status === STATUS.executed
    ) {
      return (
        <div className="status d-flex justify-content-center align-items-center">
          募集が終了しています
        </div>
      );
    }
  } else if (
    project.status !== STATUS.failed &&
    (moment(project.start_at).isAfter(moment()) || project.products_size === 0)
  ) {
    return (
      <div className="status d-flex">
        <div className="flex-fill h-100 border-right d-flex flex-column justify-content-center align-items-center">
          <div className="value">
            {moment(project.start_at).format('YYYY年MM月DD日 HH:mm')}
          </div>
          <div className="title">お申し込み開始</div>
        </div>
      </div>
    );
  } else if (project.status === STATUS.failed) {
    if (project.is_withdraw) {
      return (
        <div className="status d-flex justify-content-center align-items-center">
          募集を取り下げました
        </div>
      );
    } else {
      return (
        <div className="status d-flex justify-content-center align-items-center">
          募集が終了しています
        </div>
      );
    }
  }

  return null;
}
